import React, { useEffect, useState } from 'react';

import Grid from '@mui/material/Grid2';
import { 
  AbilityLimitation,
  CharacterLimitation,
  CreatureLimitation,
  ItemLimitation,
  Limitation,
  // LimitationType,
  SpellLimitation,
  WeaponLimitation, 
} from "@dndModels";

import CharacterLimitationBox from "@dndComponents/limitations/CharacterLimitationBox";
import AbilityLimitInput from "@dndComponents/limitations/AbilityLimitInput";
import SpellLimitInput from "@dndComponents/limitations/SpellLimitInput";
import WeaponLimitInput from "@dndComponents/limitations/WeaponLimitInput";
import CreatureLimitInput from "@dndComponents/limitations/CreatureLimitInput";
import ItemLimitInput from "@dndComponents/limitations/ItemLimitInput";
import AddButton from "@components/input/buttons/AddButton";
import DeleteButton from "@components/input/buttons/DeleteButton";

interface Props { 
  obj: Limitation;
  // limit_type?: LimitationType;
  disabled: boolean;
  change_time: number;
  no_nesting?: boolean;
  onChange: (changed: Limitation) => void; 
  onDelete: () => void; 
}

export default function LimitationInput({
  obj,
  // limit_type,
  disabled,
  change_time,
  no_nesting = false,
  onChange,
  onDelete
}: Props) {
  const [reloading, setReloading] = useState(false);
  // const [fetched, setFetched] = useState(false);

  // // eslint-disable-next-line
  // useEffect(() => {
  //   if (!fetched) {
  //     setFetched(true);
  //   }
  // });

  useEffect(() => {
    if (reloading) {
      setReloading(false);
    }
  }, [reloading, setReloading]);

  const renderLimit = () => {
    if (obj instanceof CharacterLimitation) {
      return (
        <CharacterLimitationBox
          obj={obj}
          change_time={change_time}
          disabled={disabled}
          onChange={onChange}
          onDelete={onDelete}
        />
      );
    } else if (obj instanceof AbilityLimitation) {
      return (
        <AbilityLimitInput
          obj={obj}
          change_time={change_time}
          disabled={disabled}
          onChange={onChange}
          onDelete={onDelete}
        />
      );
    } else if (obj instanceof SpellLimitation) {
      return (
        <SpellLimitInput
          obj={obj}
          change_time={change_time}
          disabled={disabled}
          onChange={onChange}
          onDelete={onDelete}
        />
      );
    } else if (obj instanceof WeaponLimitation) {
      return (
        <WeaponLimitInput
          obj={obj}
          change_time={change_time}
          disabled={disabled}
          onChange={onChange}
          onDelete={onDelete}
        />
      );
    } else if (obj instanceof ItemLimitation) {
      return (
        <ItemLimitInput
          obj={obj}
          change_time={change_time}
          disabled={disabled}
          onChange={onChange}
          onDelete={onDelete}
        />
      );
    } else if (obj instanceof CreatureLimitation) {
      return (
        <CreatureLimitInput
          obj={obj}
          change_time={change_time}
          disabled={disabled}
          onChange={onChange}
          onDelete={onDelete}
        />
      );
    }
  }
  return (
    <Grid container spacing={0} direction="row">
      <Grid
        size={{
          xs: 12
        }}>
        { renderLimit() }
      </Grid>
      { !no_nesting &&
        <>
          <Grid
            size={{
              xs: 12
            }}>
            <AddButton
              label="Add Additional Limit"
              disabled={disabled}
              onClick={() => {
                let new_limit = new Limitation();
                if (obj instanceof CharacterLimitation) {
                  new_limit = new CharacterLimitation();
                } else if (obj instanceof AbilityLimitation) {
                  new_limit = new AbilityLimitation();
                } else if (obj instanceof SpellLimitation) {
                  new_limit = new SpellLimitation();
                } else if (obj instanceof WeaponLimitation) {
                  new_limit = new WeaponLimitation();
                } else if (obj instanceof ItemLimitation) {
                  new_limit = new ItemLimitation();
                } else if (obj instanceof CreatureLimitation) {
                  new_limit = new CreatureLimitation();
                }
                obj.nested.push(new_limit);
                onChange(obj);
                setReloading(true);
              }}
            />
          </Grid>
          { !reloading && obj.nested.map(n => {
            // console.log(n);
            return (
              <Grid
                key={n.true_id}
                container
                spacing={0}
                direction="row"
                size={{
                  xs: 12
                }}>
                <Grid
                  size={{
                    xs: 12
                  }}>
                  <DeleteButton
                    disabled={disabled}
                    onClick={() => {
                      obj.nested = obj.nested.filter(o => o.true_id !== n.true_id);
                      onChange(obj);
                      setReloading(true);
                    }}
                  />
                </Grid>
                <Grid
                  size={{
                    xs: 12
                  }}>
                  <LimitationInput
                    obj={n}
                    disabled={disabled}
                    change_time={change_time}
                    no_nesting
                    onChange={(changed: Limitation) => {
                      const nested = obj.nested.find(o => o.true_id === n.true_id);
                      if (nested) {
                        nested.copy(changed);
                      }
                      onChange(obj);
                    }}
                    onDelete={() => {
                      obj.nested = obj.nested.filter(o => o.true_id !== n.true_id);
                      onChange(obj);
                      setReloading(true);
                    }}
                  />
                </Grid>
              </Grid>
            );
          })}
        </>
      }
    </Grid>
  );
}